<template>
  <div class="container">
    <head-nav-bar title="会员详情" :fixed="true"> </head-nav-bar>
    <div class="mt-header-nav" style="margin-bottom:50px;">
      <div class="card">
        <div class="card-title">基本信息</div>
        <div class="card-content">
          <news-card :data="info" size="small" descField="Phone">
            <div slot="desc" style="color:#07c160">
              <span :class="{ 'is-forbid': isforbid }"> {{ statusName }}</span>
              <van-switch
                style="float:right"
                @click="updateStatus"
                size="20px"
                inactive-color="#ddd"
                active-color="#07c160"
                :value="!isforbid"
              />
              <!-- <van-button
                style="float:right"
                size="mini"
                :type="isforbid ? 'primary' : 'danger'"
                @click="updateStatus"
                round
                >{{ isforbid ? "启用" : "禁用" }}</van-button
              > -->
            </div>
          </news-card>
          <cell-box style="padding: 0.3rem 0;" :column="2">
            <cell-item label="出生日期：" :value="info.BirthDate" />
            <cell-item label="国籍：" :value="info.Country" />
            <cell-item
              label="证件类型："
              :value="info.IDTypeText"
              style="gridColumn:span 2;"
            />
            <cell-item
              label="证件号码："
              :value="info.IDNo"
              style="gridColumn:span 2;"
            />
          </cell-box>
        </div>
      </div>

      <div class="card">
        <div class="card-title">
          卡片信息<van-button
            style="float:right;padding: 0 10px;margin-right:5px"
            size="mini"
            type="primary"
            @click="modifyPass"
            round
            >修改密码</van-button
          >
        </div>
        <div class="card-content">
          <cell-box style="padding: 0.3rem 0;" :column="2">
            <cell-item label="卡号：" :value="info.CardNo" />
            <cell-item label="卡类：" :value="info.MemberCardTypeName" />
            <cell-item label="消费总额：" :value="info.ConsumeTotalAmount" />
            <cell-item label="余额：" :value="info.Balance" />
            <cell-item label="积分余额：" :value="info.PointBalance" />
          </cell-box>
        </div>
      </div>

      <div class="card">
        <div class="card-title">备注信息</div>
        <div class="card-content">
          <p style="padding:10px;font-size:14px;">{{ info.MemberRemark }}</p>
        </div>
      </div>
    </div>
    <div class="footer-actions">
      <van-row gutter="5">
        <van-col span="7">
          <van-button
            block
            :to="{ name: 'memberAccountRecord', query: { Id: info.Id } }"
            >消费记录
          </van-button>
        </van-col>
        <van-col span="6">
          <van-button
            type="info"
            block
            :to="{ name: 'memberRecharge', query: { Id: info.Id } }"
          >
            充值
          </van-button>
        </van-col>
        <van-col span="5">
          <van-button
            type="info"
            block
            :to="{ name: 'memberConsume', query: { Id: info.Id } }"
            >消费
          </van-button>
        </van-col>
        <van-col span="6">
          <van-button
            type="primary"
            block
            :to="{ name: 'memberAdd', query: { Id: info.Id } }"
            >修改
          </van-button>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import { getMemberInfo, updateStatus } from "@/api/member.js";
import { CellBox, CellItem } from "@/components/cell";
import { Button, Panel, Notify, Row, Col, Toast, Switch } from "vant";
import NewsCard from "@/components/NewsCard";

export default {
  components: {
    [Button.name]: Button,
    [Panel.name]: Panel,
    [Row.name]: Row,
    [Col.name]: Col,
    [Switch.name]: Switch,
    CellBox,
    CellItem,
    NewsCard,
  },
  data() {
    return {
      info: {},
      memberId: "",
      statusName: "",
      isforbid: false,
    };
  },
  created() {
    const id = this.$route.query.Id;
    if (!id) {
      Notify("缺少必要参数!");
      setTimeout(() => {
        this.$router.go(-1);
      }, 2000);
      return false;
    }
    this.memberId = id;
    this.getInfo(id);
  },
  methods: {
    getInfo(id) {
      getMemberInfo({ Id: id }).then(res => {
        this.info = res.Data;
        this.statusName = this.info.Status == "1" ? "已启用" : "已禁用";
        this.isforbid = this.info.Status == "4";
      });
    },
    updateStatus() {
      const status = this.info.Status == "1" ? 4 : 1;
      updateStatus({ Id: this.memberId, Status: status }).then(() => {
        Toast.success("修改成功");
        this.getInfo(this.memberId);
      });
    },
    modifyPass() {
      this.$router.push({
        name: "memberModifyPass",
        query: {
          Id: this.memberId,
        },
      });
    },
  },
};
</script>
<style lang="less">
.is-forbid {
  color: #f00;
}
</style>
